export enum COLLECTION_FILTER_IDS {
  COLOR = "filter.v.t.shopify.color-pattern",
  MATERIAL = "filter.p.m.category.material",
  PRICE = "filter.v.price",
  SIZE = "filter.p.m.category.size",
}

export enum INTERNAL_COLLECTION_FILTER_IDS {
  COLLECTION_NAME = "filter.v.m.collection.name",
}

export enum COLLECTION_PARAMS {
  COLOR = "color",
  MATERIAL = "material",
  PRICE = "price",
  SIZE = "size",
  SORT = "sort",
}

export const COLLECTION_FILTER_INITIAL_LIST_SIZES: {
  [key in COLLECTION_FILTER_IDS]?: number;
} = {
  [COLLECTION_FILTER_IDS.COLOR]: 12,
  [COLLECTION_FILTER_IDS.MATERIAL]: 4,
  [COLLECTION_FILTER_IDS.SIZE]: 12,
};
